export default __webpack_public_path__ + "static/knightbus-fea7e4e947453e70358cc0df84f3ad11.png";